/**
 * Solver natijalari. Konvergensiya bo'lmasa xato TASHLANMAYDI —
 * `converged: false` va `message` (i18n kaliti) qaytariladi, chunki
 * talaba uchun "kolonna cho'kib ketdi" tipidagi diagnostika kerak,
 * stack trace emas.
 */

export interface SolverResult<T = number> {
  converged: boolean;
  value: T;
  iterations: number;
  /** |f(x)| yoki ||F(x)||∞ */
  residual: number;
  /** Konvergensiya bo'lmasa sabab kodi */
  message?: SolverMessage;
}

export type SolverMessage =
  | 'solver.noBracket' // bisection: f(a) va f(b) bir xil ishorali
  | 'solver.maxIterations'
  | 'solver.singularJacobian'
  | 'solver.nonFinite' // NaN yoki Infinity paydo bo'ldi
  | 'solver.stalled'; // qadam juda kichik, lekin qoldiq katta

export interface ScalarSolverOptions {
  /** x bo'yicha absolyut tolerans */
  xtol?: number;
  /** f(x) bo'yicha absolyut tolerans */
  ftol?: number;
  maxIter?: number;
}

export const DEFAULT_XTOL = 1e-10;
export const DEFAULT_FTOL = 1e-10;
export const DEFAULT_MAX_ITER = 100;
